require('./bootstrap');
//import * as bootstrap from 'bootstrap';
//window.bootstrap = bootstrap;
import ujs from '@rails/ujs';
ujs.start();